import React, { useCallback, useEffect } from "react";
import * as Contacts from "expo-contacts";
import { ContractSignatureStatus, ProfileType } from "../__generated__/graphql";
import { useI18n } from "./i18n-hooks";

export const useContactsStatus = () => {
    const [status, setStatus] = React.useState<Contacts.PermissionStatus | null>(null);
    useEffect(() => {
        const _func = async () => {
            const { status: existingStatus } = await Contacts.getPermissionsAsync();
            setStatus(existingStatus);
        };
        void _func();
    }, []);
    return status;
};
type StatusMapEntry = { [key in ContractSignatureStatus]: (profileType: ProfileType) => string };

const STATUS_TEXT_MAP: StatusMapEntry = {
    [ContractSignatureStatus.CanceledByLse]: () =>
        "screens.user.contract_details.signature_canceled_by_lift",
    [ContractSignatureStatus.CanceledByOther]: (profileType: ProfileType) =>
        profileType === ProfileType.Worker
            ? "screens.user.contract_details.signature_canceled_by_client"
            : "screens.user.contract_details.signature_canceled_by_worker",
    [ContractSignatureStatus.CanceledBySelf]: () =>
        "screens.user.contract_details.signature_cancelled_by_self",
    [ContractSignatureStatus.Failed]: () => "screens.user.contract_details.signature_failed",
    [ContractSignatureStatus.Success]: () => "screens.user.contract_details.signature_success",
    [ContractSignatureStatus.WaitingContract]: () =>
        "screens.user.contract_details.processing_contracts",
    [ContractSignatureStatus.NeedSeal]: () =>
        "screens.user.contract_details.awaiting_lift_signature",
    [ContractSignatureStatus.WaitingSelfSign]: () =>
        "screens.user.contract_details.awaiting_your_signature",
    [ContractSignatureStatus.NeedSelfSign]: () =>
        "screens.user.contract_details.awaiting_your_signature",
    [ContractSignatureStatus.NeedOtherSign]: (profileType: ProfileType) =>
        profileType === ProfileType.Worker
            ? "screens.user.contract_details.awaiting_client_signature"
            : "screens.user.contract_details.awaiting_talent_signature",
};

export const useContractSigningInfo = () => {
    const i18n = useI18n();
    const getStatusText = useCallback(
        (profileType: ProfileType, signingStatus?: ContractSignatureStatus) => {
            return i18n.t(
                STATUS_TEXT_MAP[signingStatus ?? ContractSignatureStatus.WaitingContract](
                    profileType,
                ),
            );
        },
        [i18n],
    );
    return { getStatusText };
};
